import { WORKOUT_KEY } from '../../../../../modules/workout/model/constants/key'
import { getValueReduxUtil } from '../../../../redux/utils/get-value'

function getPlanIdWorkoutUtil (workout) {
  return getValueReduxUtil(workout, WORKOUT_KEY.PLAN_ID)
}

export default getPlanIdWorkoutUtil
